// actions.js
import * as actionTypes from "./actionsTypes";

export const setValueCgp = (value) => ({
  type: actionTypes.SET_VALUE_CGP,
  payload: value,
});

export const setTypeCgp = (type) => ({
  type: actionTypes.SET_TYPE_CGP,
  payload: type,
});
export const setActifCgp = (actif) => ({
  type: actionTypes.SET_ACTIF_CGP,
  payload: actif,
});

export const setCurrentPageCgp = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE_CGP,
  payload: page,
});

export const setOrderCgp = (order) => ({
  type: actionTypes.SET_ORDER_CGP,
  payload: order,
});

export const setSortFieldCgp = (field) => ({
  type: actionTypes.SET_SORT_FIELD_CGP,
  payload: field,
});
